export default {
  props: {
    itemBorderRadius: {
      type: Number,
      default: undefined,
    },
    itemBorderColor: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    itemStyles() {
      if (!this.itemBorderColor) {
        return {};
      }
      return {
        border: `1px solid ${this.itemBorderColor}`,
        borderRadius: `${this.itemBorderRadius}px`,
      };
    },
  },
};
